import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { EMPTY_DASH } from '@/helpers/constants';
import { MyTooltip } from '@/webkit/MyTooltip';
import { useWindowSize } from '@/hooks/useWindowSize';
import IconChart from './icon_chart.svg';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const StreakStatus = ({ status }) => {
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('streak');

  const title = (
    <div className="f-hero-h5">{t('streak_status.your_investment_streak')}</div>
  );

  const blocks = (
    <div className={s.blocks}>
      <div className={s.info}>
        <div className="f-article-accent">
          {status ? `+${status.income_increase.toFixed(2)}%` : ''}
        </div>
        <MyTooltip
          theme="dark"
          renderElement={() => (
            <div className={classnames('f-body-regular', s.tooltip)}>
              {t('streak_status.income_increase')}
            </div>
          )}
          renderContent={() => (
            <div className="f-small-regular">
              {t('tooltip.income_increase')}
            </div>
          )}
        />
      </div>
      <div className={s.info}>
        <div className="f-article-accent">
          {status ? `${status.net_cash_flow_bonus.toFixed(2)}%` : ''}
        </div>
        <MyTooltip
          theme="dark"
          renderElement={() => (
            <div className={classnames('f-body-regular', s.tooltip)}>
              {t('streak_status.net_cash_flow_bonus')}
            </div>
          )}
          renderContent={() => (
            <div className="f-small-regular">
              {t('tooltip.net_cash_flow_bonus')}
            </div>
          )}
        />
      </div>
    </div>
  );

  const circle = (
    <div className={s.circle}>
      <span className="f-hero-h3">{status ? status.streak : EMPTY_DASH}</span>
      {status && (
        <span className={classnames(s.badge, status.status, 'f-tiny-accent')}>
          {t(`dynamic:status.${status.status}`)}
        </span>
      )}
    </div>
  );

  const links = (
    <div className={s.links}>
      {status.streak === 0 && (
        <MyLink className={r.yellow_base} href={APP_LINKS.investing}>
          <span className="f-body-accent">
            {t('streak_status.start_investing')}
          </span>
        </MyLink>
      )}
      <MyLink className={r.grey_base} href={APP_LINKS.investmentStreakActivity}>
        <img src={IconChart} alt="chart" width={20} height={20} />
        <span className="f-body-accent">{t('streak_status.activity')}</span>
      </MyLink>
    </div>
  );

  return isMobile ? (
    <div className={s.mobile_wrapper}>
      {title}
      <div className={s.mobile_header}>
        {circle}
        {links}
      </div>
      <div className={s.mobile_blocks}>{blocks}</div>
    </div>
  ) : (
    <div className={s.wrapper}>
      {circle}
      <div className={s.main}>
        {title}
        {blocks}
      </div>
      {links}
    </div>
  );
};
